export function StringInput({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <input
      type="text"
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      className="border rounded px-2 py-1 text-sm flex-1"
    />
  )
}
